import React from 'react'
import PropTypes from 'prop-types'
import { updateObject } from 'helpers/objectHelpers'
import SpacingPicker from './SpacingPicker'
import ColorPicker from './ColorPicker'
import FormSelect from 'components/forms/bases/FormSelect'
import FormInputNumber from 'components/forms/FormInputNumber'
import FontFamilySelector from 'components/forms/FontFamilySelector'
import FontWeightSelector from 'components/forms/FontWeightSelector'
import TextDecoration from 'components/forms/TextDecorationSelector'
import TextTransform from 'components/forms/TextTransformSelector'
import FormTextAlign from 'components/forms/FormTextAlign'
import FontStyle from 'components/forms/FontStyleSelector'
import isEmpty from 'lodash/isEmpty'
import Accordion from 'components/accordions/Accordion';
import ColorsSelector from 'components/forms/ColorsSelector'
import SizesSelector from 'components/forms/SizesSelector'
import Divider from 'material-ui/Divider'

const wrapperStyle = {
  padding: 15,
  border: '1px solid #e8e8e8',
  borderRadius: 5,
  marginBottom: 10,
  marginTop: 10,
}

const switchStyle = ({
  element,
  value: {
    fontFamily = '',
    fontWeight = '',
    fontSize = '',
    fontStyle = '',
    color = '',
    lineHeight = '',
    letterSpacing = '',
    textAlign = '',
    textIndent = '',
    textDecoration = '',
    textTransform = '',
  },
  onChange,
  handleChange,
  handleChangeSettings,
  valueSettings: {
    colorTheme = '',
    sizeTheme = '',
  }
}) => {
  switch (element) {
    case 'fontFamily':
      return (
        <FontFamilySelector
          value={fontFamily}
          onChange={(val) => handleChange(val, 'fontFamily')}
        />
      )
    case 'fontWeight':
      return (
        <FontWeightSelector
          currentFamily={fontFamily}
          value={fontWeight}
          onChange={(val) => handleChange(val, 'fontWeight')}
        />
      )
    case 'fontSize':
      return (
        <FormInputNumber
          label="Font Size"
          value={fontSize}
          onChange={(val) => handleChange(val, 'fontSize')}
        />
      )
    case 'lineHeight':
      return (
        <FormInputNumber
          label="Line Height"
          value={lineHeight}
          onChange={(val) => handleChange(val, 'lineHeight')}
        />
      )
    case 'letterSpacing':
      return (
        <FormInputNumber
          label="Letter Spacing"
          value={letterSpacing}
          onChange={(val) => handleChange(val, 'letterSpacing')}
        />
      )
    case 'textIndent':
      return (
        <FormInputNumber
          label="Text Indent"
          value={textIndent}
          onChange={(val) => handleChange(val, 'textIndent')}
        />
      )
    case 'textDecoration':
      return (
        <TextDecoration
          value={textDecoration}
          onChange={(val) => handleChange(val, 'textDecoration')}
        />
      )
    case 'textTransform':
      return (
        <TextTransform
          value={textTransform}
          onChange={(val) => handleChange(val, 'textTransform')}
        />
      )
    case 'alignment':
      return (
        <FormTextAlign
          value={textAlign}
          onChange={(val) => handleChange(val, 'textAlign')}
        />
      )
    case 'fontStyle':
      return (
        <FontStyle
          value={fontStyle}
          onChange={(val) => handleChange(val, 'fontStyle')}
        />
      )
    case 'colorCustom':
      return (
        <ColorPicker
          label="Color"
          value={color}
          onChange={(val) => handleChange(val, 'color')}
        />
      )
    case 'colorTheme':
      return (
        <ColorsSelector
          value={colorTheme}
          onChange={(val) => handleChangeSettings(val, 'color')}
        />
      )
    case 'sizeTheme':
      return (
        <SizesSelector
          value={sizeTheme}
          onChange={(val) => handleChangeSettings(val, 'size')}
        />
      )
    default:
      return <div>element not match in switchStyle</div>
  }
}

const TypoForm = ({
  value,
  onChange,
  styleStructure: {
    typography: {
      basic = {},
      advance = {},
    }
  },
  valueSettings,
  valueSettings: {
    size,
    color,
  },
  onChangeSettings,
  onRerender,
}) => {
  const handleChange = (val, key) => (
    onChange(updateObject(value, { [key]: val }))
  )
  const handleChangeSettings = (val, key) => (
    onChangeSettings(updateObject(valueSettings, { [key]: val }))
  )
  return (
    <div style={wrapperStyle}>
      {!isEmpty(basic) && basic.map((item) => (
        switchStyle({
          element: item,
          value,
          onChange,
          handleChange,
          handleChangeSettings,
          valueSettings: {
            colorTheme: color,
            sizeTheme: size,
          }
        })
      ))
      }
      {!isEmpty(advance) &&
        <Accordion onTouchTab={onRerender} accordionProps={{ borderNotShow: true }} >
          <Accordion.Pane
            label="Advance"
            subValue="advance"
          >
            {advance.map((item) => (
              switchStyle({
                element: item,
                value,
                handleChange,
                onChange,
                handleChangeSettings,
                valueSettings: {
                  colorTheme: color,
                  sizeTheme: size,
                }
              })
            ))
            }
          </Accordion.Pane>
        </Accordion>
      }
    </div>
  )
}

TypoForm.propTypes = {}
TypoForm.defaultProps = {}

export default TypoForm



// WEBPACK FOOTER //
// ./src/components/forms/TypoForm.js